import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useCallback, useLayoutEffect } from 'react';
/*
 * A React hook to measure the width and height of an HTML element and
 * keep the measurements updated when the element's size changes.
 */
var useElementSize = function useElementSize() {
  var _useState = useState({
      width: 0,
      height: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    size = _useState2[0],
    setSize = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    element = _useState4[0],
    setElement = _useState4[1];
  var elementRef = useCallback(function (node) {
    setElement(node);
  }, []);
  useLayoutEffect(function () {
    if (!element) {
      return;
    }

    // Callback to update the size state
    var updateSize = function updateSize() {
      setSize({
        width: element.offsetWidth,
        height: element.offsetHeight
      });
    };

    // Create a ResizeObserver to watch the element
    var resizeObserver = new ResizeObserver(updateSize);
    resizeObserver.observe(element);

    // Set initial size
    updateSize();

    // Cleanup
    return function () {
      return resizeObserver.disconnect();
    };
  }, [element]);
  return {
    width: size.width,
    height: size.height,
    elementRef: elementRef
  };
};
export default useElementSize;